export default __webpack_public_path__ + "static/media/paymentGatewayIcon.df74e960.png";